import  { useEffect, useState  } from 'react';
import { useNavigate  } from 'react-router-dom';
import { MailOutlined, LockOutlined , EyeOutlined, EyeInvisibleOutlined  } from '@ant-design/icons';
import {  Button } from 'antd';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgotPasswordModal from '../../modals/ForgotPasswordModal';
import illustration from './assets/login-illustration.png';

const LoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ Email: '', Password: '' });
  const [touched, setTouched] = useState({ Email: false, Password: false });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
   
   const token = localStorage.getItem('token');
   const role = localStorage.getItem('role');
    useEffect(() => {
      if(token != null) {
        navigate('/')
      } 

      if(role != null) {
     if(role === "ADMIN") {
      navigate('/admin-home')
     }else {
      navigate('/user-home')
     }
    }

      
    }, []);

  const isEmailValid = /\S+@\S+\.\S+/.test(form.Email);
  const isPasswordValid = form.Password.length >= 6;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBlur = (e) => {
    setTouched({ ...touched, [e.target.name]: true });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/user/login`, form);
      // console.log(response);
      
      if (response.data.success) {  
        localStorage.setItem('tempToken', response.data.token); // Save for OTP step
        toast.success('OTP sent to your email', { position: 'top-center' });
        navigate('/verify-otp');
      } else {
        toast.error('Invalid email or password', { position: 'top-center' });
      }
    } catch (err) {
      toast.error('Login failed. Invalid email or password.', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-6 bg-gradient-to-br from-violet-200 via-white to-red-200">
       <ToastContainer
              position="bottom-left"
              autoClose={5000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              className="!mb-6 !ml-4"
              toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
            />

      <div className="grid w-full max-w-5xl grid-cols-1 overflow-hidden bg-white shadow-2xl rounded-2xl md:grid-cols-2">
        {/* Left side - illustrative image */}
        <div className="items-center justify-center hidden p-8 bg-gray-100 md:flex">
          {/* Replace src with your image path or use an <svg> illustration */}
          <img
            src={illustration}
            alt="Login illustration"
            className="object-contain h-auto max-w-full rounded-lg "
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
         
        </div>

        {/* Right side - form */}
        <div className="px-8 py-10">
          <div className="max-w-md mx-auto">
            <h2 className="mb-2 text-3xl font-extrabold text-black">Login</h2>
            <p className="mb-6 text-sm text-gray-500">Enter your credentials to continue</p>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Email Field */}
              <div className="relative">
                <label htmlFor="Email" className="block mb-1 text-sm font-semibold text-gray-700">Email</label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                    <MailOutlined />
                  </span>
                  <input
                    type="email"
                    name="Email"
                    id="email"
                    value={form.Email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="you@example.com"
                    className={`w-full pl-10 pr-4 py-2 rounded-lg border transition focus:outline-none focus:ring-2
                    ${!touched.Email ? 'border-gray-300 focus:ring-blue-500' :
                      isEmailValid ? 'border-green-500 focus:ring-green-500' : 'border-red-500 focus:ring-red-500'}`}
                  />
                </div>
              </div>

             {/* Password Field */}
<div className="relative">
  <label htmlFor="Password" className="block mb-1 text-sm font-semibold text-gray-700">
    Password
  </label>
  <div className="relative">
    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
      <LockOutlined />
    </span>

    <input
      type={showPassword ? "text" : "password"}
      name="Password"
      id="password"
      value={form.Password}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="••••••"
      className={`w-full pl-10 pr-10 py-2 rounded-lg border transition focus:outline-none focus:ring-2
      ${
        !touched.Password
          ? "border-gray-300 focus:ring-blue-500"
          : isPasswordValid
          ? "border-green-500 focus:ring-green-500"
          : "border-red-500 focus:ring-red-500"
      }`}
    />

    {/* Eye icon toggle */}
    <button
      type="button"
      onClick={() => setShowPassword((prev) => !prev)}
      className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 focus:outline-none"
    >
      {showPassword ? (
        <EyeInvisibleOutlined className="text-xl" />
      ) : (
        <EyeOutlined className="text-xl" />
      )}
    </button>
  </div>

  {touched.Password && !isPasswordValid && (
    <p className="mt-1 text-sm text-red-500">Password must be at least 6 characters</p>
  )}
</div>


              {/* Forgot Password Link */}
              <div className="flex items-center justify-between">
                <div />
                <ForgotPasswordModal
                  trigger={
                    <Button
                      type="link"
                      className="text-sm font-semibold text-red-500"
                    >
                      Forgot password?
                    </Button>
                  }
                />
              </div>

              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2 text-lg font-semibold text-white transition bg-black rounded-lg hover:bg-blue-800 disabled:opacity-50"
                >
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </div>
            </form>

            {/* Optional error message area */}
            {error && <p className="mt-4 text-sm text-red-500">{error}</p>}

            {/* Small footer */}
            <div className="mt-6 text-sm text-center text-gray-400">
              &copy; {new Date().getFullYear()} Practical Infosec
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
